import { makeApiCall } from "../apiRequest";

export default {
  state: {
    allDepartment: [],
  },
  getters: {
    getAllDepartment: (state) => state.allDepartment,
  },
  actions: {
    async getAllDepartment({ commit }, obj) {
      let url = `superAdminDepartment/getAll`;
      const response = await makeApiCall(url, "POST", obj);
      if (!response.error) {
        commit("setAllDepartment", response.data);
      }
      return response;
    },
    async createDepartment({ commit }, payload) {
      const response = await makeApiCall("superAdminDepartment/save", "POST", payload);
      return response;
    },
    async deleteDepartment({ commit }, payload) {
      const response = await makeApiCall(
        `superAdminDepartment/delete`,
        "DELETE",
        payload
      );
      return response;
    },
  },
  mutations: {
    setAllDepartment: (state, payload) => (state.allDepartment = payload),
  },
};
